<ng-container *ngIf="docList && docList.length > 0">
    <div style="font-size: 14px" *ngFor="let dl of docList; trackBy: trackByDocId" class="docs divider"
        [ngClass]="{'active': dl.docId === currentDocumentSnapshot?.docId}" (click)="loadDocument(dl.docId)">
        <lex-doc-node [node]="dl" [isSelected]="dl.docId === currentDocumentSnapshot?.docId"
            style="overflow:auto; "></lex-doc-node>
    </div>
</ng-container>